// extracted by mini-css-extract-plugin
export default {"cancelTicket":"listitems_cancelTicket__fnBT9","list_item":"listitems_list_item__VCWGC"};